// Path of the members-only area. Must match the "starts with" rule in
// Outseta > Auth > Protected Content. Do not use "/members": Outseta matches
// on a plain prefix, so that would also protect "/membership".
export const MEMBERS_PATH = '/members-area';
